<div class="landing-page-wrapper">
  <!-- 1. GLOBAL NAVIGATION HEADER (STICKY GLASSMORPHISM ISLAND) -->
  <div class="nav-outer">
    <nav class="glass-nav">
      <img src="assets/images/new-logo.png" alt="Certiplate Logo" class="logo-img" (click)="scrollToTop()" />
      <div class="nav-actions">
        <a (click)="navigateToContactUs()" class="btn btn-outline nav-contact-btn">Contact Us</a>

        <div class="login-dropdown-wrapper">
          <button (click)="toggleLoginDropdown(); $event.stopPropagation()" class="btn btn-solid nav-login-btn">
            <span>Login</span>
            <span class="dropdown-chevron">▼</span>
          </button>

          <div *ngIf="isLoginDropdownOpen" class="login-dropdown-menu" (click)="$event.stopPropagation()">
            <a (click)="adminportal(); toggleLoginDropdown()" class="dropdown-item">
              <svg class="dropdown-icon" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
              <span class="item-title">Admin Portal</span>
            </a>

            <a (click)="candidateportal(); toggleLoginDropdown()" class="dropdown-item">
              <svg class="dropdown-icon" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
              </svg>
              <span class="item-title">Exam Portal</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  </div>

  <!-- 2. HERO SECTION -->
  <div class="hero-outer">
    <div class="hero-shell">
      <section class="hero">
        <div class="hero-grid">
          <div class="hero-copy">
            <div class="eyebrow"><span class="dot"></span> Certiplate by Navriti Technologies</div>
            <h1>Secure, Scalable Online <br />Assessments-<span class="accent-green">Powered by AI</span></h1>
            <p>Your complete digital assessment platform-designed for scalability, security, and fairness in online
              exams.</p>
            <a class="btn-hero-cta" (click)="navigateToBookDemo()" style="cursor: pointer;">Book a Demo <span class="cta-arrow-circle">→</span></a>
          </div>
          <div class="hero-visual">
            <img src="assets/images/hero-mockup-new.png" alt="Certiplate Dashboard Overview"
              class="hero-mockup-img floating-mockup" />
          </div>
        </div>

        <div class="hero-bottom-left">
          <div class="trust-row">
            <div class="trust-avatars-cluster">
              <div class="trust-avatar-item"><img src="assets/images/Logos/01_Pondicherry_University.png"
                  alt="Pondicherry University" /></div>
              <div class="trust-avatar-item"><img src="assets/images/Logos/02_Don_Bosco_Tech.png"
                  alt="Don Bosco Tech" /></div>
              <div class="trust-avatar-item"><img src="assets/images/Logos/13_BWSSC.png" alt="BWSSC" /></div>
              <div class="trust-avatar-item"><img src="assets/images/Logos/10_Gold_Emblem.png" alt="Gold Emblem" />
              </div>
            </div>
            <span class="trust-text"><b>500+</b> institutions trust Certiplate</span>
          </div>
        </div>

        <!-- Stats Component (Cutout Box attached to bottom-right of hero) -->
        <div class="hero-stats" id="heroStatsSection">
          <div class="stat">
            <b class="counter-num" data-target="2">2M+</b>
            <span>Candidates<br>Evaluated.</span>
          </div>
          <div class="stat">
            <b class="counter-num" data-target="99.9">99.9%</b>
            <span>Uptime in<br>Remote<br>Locations.</span>
          </div>
          <div class="stat">
            <b class="counter-num" data-target="600">600+</b>
            <span>Skills/Courses<br>Supported.</span>
          </div>
        </div>
      </section>
    </div>
  </div>

  <!-- 3. TRUSTED INSTITUTIONS LOGO CLOUD (2-ROW INFINITE MARQUEE) -->
  <section class="trusted-cloud-section">
    <div class="trusted-head">
      <h2>Trusted by <span class="accent-green">Leading</span> Institutions and Organizations</h2>
    </div>

    <div class="logo-marquee-container">
      <!-- Row 1: Forward Marquee -->
      <div class="logo-marquee-track track-row-1">
        <div class="individual-logo-card" *ngFor="let logo of partnerLogosRow1">
          <img [src]="logo.image" [alt]="logo.name" [title]="logo.name" class="partner-logo-img" />
        </div>
        <div class="individual-logo-card" *ngFor="let logo of partnerLogosRow1">
          <img [src]="logo.image" [alt]="logo.name" [title]="logo.name" class="partner-logo-img" />
        </div>
      </div>

      <!-- Row 2: Reverse Marquee -->
      <div class="logo-marquee-track track-row-2">
        <div class="individual-logo-card" *ngFor="let logo of partnerLogosRow2">
          <img [src]="logo.image" [alt]="logo.name" [title]="logo.name" class="partner-logo-img" />
        </div>
        <div class="individual-logo-card" *ngFor="let logo of partnerLogosRow2">
          <img [src]="logo.image" [alt]="logo.name" [title]="logo.name" class="partner-logo-img" />
        </div>
      </div>
    </div>
  </section>

  <!-- 4. PRODUCT EXPERIENCE (VIDEO SECTION) -->
  <section class="product-exp">
    <div class="exp-header">
      <div class="exp-eyebrow">Product Experience</div>
      <h2>See the platform in <span class="accent-green">action</span></h2>
    </div>

    <div class="video-container-stage">
      <div class="video-poster-box">
        <!-- Embedded Video Iframe (Loaded from the start) -->
        <iframe *ngIf="safeYoutubeUrl" [src]="isPlayingVideo ? safeYoutubePlayUrl : safeYoutubeUrl"
          title="Certiplate Product Demo Video" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen class="embedded-card-iframe">
        </iframe>

        <!-- Poster Card Overlay with Play Button & Badge (Visible before play is clicked) -->
        <div class="poster-overlay" *ngIf="!isPlayingVideo" (click)="playVideo()">
          <div class="play-pulse-btn" title="Play Video Demo">
            <div class="play-triangle"></div>
          </div>
          <div class="floating-badge-learners">
            <span class="green-indicator-dot"></span>
            <span>"Helping 5k+ learners daily"</span>
          </div>
        </div>

        <!-- Pause / Show Overlay Button (Visible when playing) -->
        <button class="close-video-btn" *ngIf="isPlayingVideo" (click)="closeVideo()" title="Pause & Show Overlay">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <rect x="6" y="4" width="4" height="16" rx="1"></rect>
            <rect x="14" y="4" width="4" height="16" rx="1"></rect>
          </svg>
        </button>
      </div>
    </div>
  </section>

  <!-- 5. SCROLLING PRODUCT TAGLINE (INFINITE MARQUEE BAND) -->
  <section class="tagline-marquee-band">
    <div class="tagline-marquee-track">
      <div class="tagline-phrase">Eliminate <span class="accent-green">Cheating</span>. Empower <span
          class="accent-green">Learning</span>. Fair Exams. <span class="accent-green">Every Time</span>.&nbsp;</div>
      <div class="tagline-phrase">Eliminate <span class="accent-green">Cheating</span>. Empower <span
          class="accent-green">Learning</span>. Fair Exams. <span class="accent-green">Every Time</span>.&nbsp;</div>
      <div class="tagline-phrase">Eliminate <span class="accent-green">Cheating</span>. Empower <span
          class="accent-green">Learning</span>. Fair Exams. <span class="accent-green">Every Time</span>.&nbsp;</div>
    </div>
  </section>

  <!-- PROBLEM -->
  <section class="problem-section">
    <h2 class="problem-label">The Problem</h2>
    <div class="problem-list">
      <div class="problem-item">
        <div class="problem-num">01</div>
        <div class="problem-content">
          <h4>Online exams lack integrity</h4>
          <p>Without robust proctoring, assessment results lose credibility and trust.</p>
        </div>
      </div>
      <div class="problem-item">
        <div class="problem-num">02</div>
        <div class="problem-content">
          <h4>Scaling assessments is complex</h4>
          <p>Infrastructure bottlenecks prevent organizations from evaluating at scale.</p>
        </div>
      </div>
      <div class="problem-item">
        <div class="problem-num">03</div>
        <div class="problem-content">
          <h4>Manual evaluation slows outcomes</h4>
          <p>Time-consuming grading delays results and hampers decision-making.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- SOLUTION -->
  <section class="solution-section">
    <div class="solution-grid">
      <div class="solution-content">
        <div class="solution-label">The Solution</div>
        <h2 class="solution-title">Certiplate replaces fragmented tools with a <span class="solution-highlight">unified,
            intelligent assessment system.</span></h2>
        <p class="solution-description">One platform for creation, delivery, proctoring, and analytics—built for scale
          and security.</p>
      </div>
      <div class="solution-visual-wrapper">
        <div class="solution-visual-card">
          <img src="assets/solution-dashboard-mockup.png" alt="Certiplate Solution Dashboard Showcase"
            class="solution-dashboard-img" />
        </div>
      </div>
    </div>
  </section>

  <!-- CORE CAPABILITIES -->
  <section class="capabilities">
    <div class="cap-header">
      <div class="cap-eyebrow">Core Capabilities</div>
      <h2>Built for <span class="accent-green">precision</span> at every layer</h2>
    </div>

    <div class="cap-bento-grid">
      <!-- A. Spotlight Card: AI Proctoring (Row Span 3 / Double Height) -->
      <div class="cap-card cap-spotlight bento-left-animate">
        <!-- Integrated UI Mockup Stage (Exact Image) -->
        <div class="spotlight-visual-stage">
          <img src="assets/images/ai-proctoring-card.png" alt="AI Proctoring Feature Illustration"
            class="spotlight-img" />
        </div>
      </div>

      <!-- B. Standard Cards Column (Right Column & Bottom Row) -->
      <div class="cap-card bento-right-animate">
        <div class="cap-card-header">
          <div class="cap-icon-box">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 3v18h18" />
              <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3" />
            </svg>
          </div>
          <div class="cap-card-title-group">
            <h3>Analytics Engine</h3>
            <div class="sub-headline">Turn performance into insights</div>
          </div>
        </div>
        <p class="cap-body">Real-time dashboards, candidate scoring, and performance trends.</p>
      </div>

      <div class="cap-card bento-right-animate">
        <div class="cap-card-header">
          <div class="cap-icon-box">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
          </div>
          <div class="cap-card-title-group">
            <h3>Scalable Delivery</h3>
            <div class="sub-headline">Run exams for thousands simultaneously</div>
          </div>
        </div>
        <p class="cap-body">Auto-scaling infrastructure handles peak loads without downtime.</p>
      </div>

      <div class="cap-card bento-right-animate">
        <div class="cap-card-header">
          <div class="cap-icon-box">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
            </svg>
          </div>
          <div class="cap-card-title-group">
            <h3>Seamless Integration</h3>
            <div class="sub-headline">Fits into your ecosystem</div>
          </div>
        </div>
        <p class="cap-body">LMS plugins, REST APIs, SSO, and webhook support out of the box.</p>
      </div>

      <div class="cap-card bento-right-animate">
        <div class="cap-card-header">
          <div class="cap-icon-box">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
              <line x1="12" y1="18" x2="12.01" y2="18" />
            </svg>
          </div>
          <div class="cap-card-title-group">
            <h3>Mobile-Ready Experience</h3>
            <div class="sub-headline">Access your assessments anytime, anywhere across devices.</div>
          </div>
        </div>
        <p class="cap-body">Deliver seamless assessments that adapt to any screen size. Ensure a consistent for every
          candidate.</p>
      </div>

      <div class="cap-card bento-right-animate">
        <div class="cap-card-header">
          <div class="cap-icon-box">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </div>
          <div class="cap-card-title-group">
            <h3>Instant results</h3>
            <div class="sub-headline">Auto-grading with explainable AI in seconds, not days.</div>
          </div>
        </div>
        <p class="cap-body">Get immediate performance insights with automated scoring. Reduce turnaround time and
          streamline your decision-making.</p>
      </div>
    </div>
  </section>

  <!-- HOW IT WORKS -->
  <div class="how-outer">
    <section class="how">
      <div class="how-header">
        <h2>How It <span class="accent-green">Works</span> ?</h2>
        <p class="how-sub">Three simple steps to secure, scalable assessments.</p>
      </div>

      <div class="steps-grid">
        <!-- Step 01 -->
        <div class="process-card">
          <div class="step-badge">Step 01</div>
          <div class="glow-icon-stage">
            <div class="glow-circle"></div>
            <div class="icon-inner-box">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </div>
          </div>
          <h3>Create Exam</h3>
          <p>Set up questions, rules, and scheduling in minutes.</p>
        </div>

        <!-- Step 02 -->
        <div class="process-card">
          <div class="step-badge">Step 02</div>
          <div class="glow-icon-stage">
            <div class="glow-circle"></div>
            <div class="icon-inner-box">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
                <path d="M12 7v5" />
                <path d="M9 10l3 3 3-3" />
              </svg>
            </div>
          </div>
          <h3>Conduct Securely</h3>
          <p>AI proctoring and lockdown ensure exam integrity.</p>
        </div>

        <!-- Step 03 -->
        <div class="process-card">
          <div class="step-badge">Step 03</div>
          <div class="glow-icon-stage">
            <div class="glow-circle"></div>
            <div class="icon-inner-box">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                <path d="M9 12h6" />
                <path d="M9 16h6" />
              </svg>
            </div>
          </div>
          <h3>Analyze Results</h3>
          <p>Get instant analytics, reports, and actionable insights.</p>
        </div>
      </div>
    </section>
  </div>

  <!-- USE CASES -->
  <section class="usecases">
    <div class="uc-header">
      <div class="uc-eyebrow">Use Cases</div>
      <h2>Purpose-built for every <br /><span class="accent-green">assessment</span></h2>
    </div>
    <div class="uc-grid">
      <!-- Card 1: Accreditation Bodies -->
      <div class="uc-card">
        <div class="uc-icon-box">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00B86B" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
            <path d="M6 12v5c3 3 9 3 12 0v-5" />
          </svg>
        </div>
        <h3>Accreditation Bodies</h3>
        <p>Facilitate high-stakes certification programs with enterprise-grade security, ensuring total compliance and
          audit-ready credentialing for global industries.</p>
      </div>

      <!-- Card 2: Institutional Learning -->
      <div class="uc-card">
        <div class="uc-icon-box">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00B86B" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
          </svg>
        </div>
        <h3>Institutional Learning</h3>
        <p>Streamline academic and vocational assessment workflows for universities and K-12 systems with scalable,
          high-integrity examination frameworks.</p>
      </div>

      <!-- Card 3: Impact & Social Sector -->
      <div class="uc-card">
        <div class="uc-icon-box">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00B86B" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
            <path d="M9 22v-4h6v4" />
            <path d="M8 6h.01M16 6h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01" />
          </svg>
        </div>
        <h3>Impact &amp; Social Sector</h3>
        <p>Optimize large-scale talent development and social initiatives by leveraging data-driven beneficiary
          screening and measurable impact evaluation.</p>
      </div>

      <!-- Card 4: High-Stakes Test Prep -->
      <div class="uc-card">
        <div class="uc-icon-box">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00B86B" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="8" r="6" />
            <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
          </svg>
        </div>
        <h3>High-Stakes Test Prep</h3>
        <p>Empower coaching centers and digital platforms with advanced adaptive testing technology, performance
          benchmarking, and competitive exam simulations.</p>
      </div>
    </div>
  </section>

  <!-- WHY CERTIPLATE -->
  <section class="compare">
    <div class="compare-header">
      <div class="compare-eyebrow">Why Certiplate</div>
      <h2>A different <span class="accent-green">standard</span></h2>
    </div>

    <div class="compare-stage">
      <div class="compare-grid">
        <!-- Traditional Systems (The Problem Card) -->
        <div class="compare-card compare-trad">
          <h3>Traditional Systems</h3>
          <ul>
            <li>
              <span class="icon-mark mark-x">✕</span>
              <span>Fragmented tools with no integration</span>
            </li>
            <li>
              <span class="icon-mark mark-x">✕</span>
              <span>Manual proctoring with human error</span>
            </li>
            <li>
              <span class="icon-mark mark-x">✕</span>
              <span>Limited to hundreds of candidates</span>
            </li>
            <li>
              <span class="icon-mark mark-x">✕</span>
              <span>Post-exam analytics only</span>
            </li>
            <li>
              <span class="icon-mark mark-x">✕</span>
              <span>Complex setup and maintenance</span>
            </li>
          </ul>
        </div>

        <!-- Certiplate (The Solution Card) -->
        <div class="compare-card compare-win">
          <h3>Certiplate</h3>
          <ul>
            <li>
              <span class="icon-mark mark-check">✓</span>
              <span>Unified platform, end-to-end</span>
            </li>
            <li>
              <span class="icon-mark mark-check">✓</span>
              <span>AI-powered proctoring with precision</span>
            </li>
            <li>
              <span class="icon-mark mark-check">✓</span>
              <span>Scale to thousands simultaneously</span>
            </li>
            <li>
              <span class="icon-mark mark-check">✓</span>
              <span>Real-time analytics and insights</span>
            </li>
            <li>
              <span class="icon-mark mark-check">✓</span>
              <span>Deploy in minutes, not months</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- PRICING -->
  <section class="pricing">
    <div class="pricing-header">
      <div class="pricing-eyebrow">Pricing</div>
      <h2>Plans that <span class="accent-green">scale with you</span></h2>
    </div>

    <div class="price-container">
      <div class="price-4col-grid">
        <!-- 1. Starter Plan -->
        <div class="price-card">
          <div class="card-top-content">
            <h3 class="plan-name">Starter</h3>
            <div class="price-rate">
              <span class="currency">₹</span>
              <span class="amount">50</span>
              <span class="per">/ Instance</span>
            </div>
            <p class="plan-desc">For independent instructors & small teams getting started with online exams.</p>
            <div class="metrics-pills">
              <div class="metric-pill">
                <span class="pill-icon">📚</span>
                <span>Up to 100 concurrent exams</span>
              </div>
              <div class="metric-pill">
                <span class="pill-icon">🏷️</span>
                <span>Up to 1000/ month total</span>
              </div>
            </div>
            <a (click)="openSubscriptionModal('Starter')" class="btn-price-cta">Get Started</a>
            <div class="card-divider"></div>
          </div>

          <div class="checklist-drawer">
            <div class="included-title">What’s included:</div>
            <ul class="checklist-list">
              <li class="item-included"><span class="check-icon">✓</span> Basic Exam Engine</li>
              <li class="item-included"><span class="check-icon">✓</span> Automated Scoring</li>
              <li class="item-included"><span class="check-icon">✓</span> Email Support</li>
              <li class="item-excluded"><span class="x-icon">✕</span> Anti-Cheating & AI Proctoring</li>
              <li class="item-excluded"><span class="x-icon">✕</span> Live Warning Generation</li>
              <li class="item-excluded"><span class="x-icon">✕</span> Bulk Transactions</li>
            </ul>
          </div>
        </div>

        <!-- 2. Standard Plan -->
        <div class="price-card">
          <div class="card-top-content">
            <h3 class="plan-name">Standard</h3>
            <div class="price-rate">
              <span class="currency">₹</span>
              <span class="amount">75</span>
              <span class="per">/ Instance</span>
            </div>
            <p class="plan-desc">Perfect for schools and colleges looking for basic automated security for online exams.
            </p>
            <div class="metrics-pills">
              <div class="metric-pill">
                <span class="pill-icon">📚</span>
                <span>Up to 500 concurrent exams</span>
              </div>
              <div class="metric-pill">
                <span class="pill-icon">🏷️</span>
                <span>Up to 5000/ month total</span>
              </div>
            </div>
            <a (click)="openSubscriptionModal('Standard')" class="btn-price-cta">Get Started</a>
            <div class="card-divider"></div>
          </div>

          <div class="checklist-drawer">
            <div class="included-title">What’s included:</div>
            <ul class="checklist-list">
              <li class="item-included"><span class="check-icon">✓</span> Everything in Starter</li>
              <li class="item-included"><span class="check-icon">✓</span> Identity Access Management (IAM)</li>
              <li class="item-included"><span class="check-icon">✓</span> Volume Bulk Transactions</li>
              <li class="item-included"><span class="check-icon">✓</span> Remote Invigilated & Live Chat</li>
              <li class="item-included"><span class="check-icon">✓</span> Live Warning Generation</li>
              <li class="item-included"><span class="check-icon">✓</span> Regular Image & Feedback Capture</li>
              <li class="item-included"><span class="check-icon">✓</span> AI Face & Tab-Switch Detection</li>
            </ul>
          </div>
        </div>

        <!-- 3. Business Plan -->
        <div class="price-card">
          <div class="card-top-content">
            <h3 class="plan-name">Business</h3>
            <div class="price-rate">
              <span class="currency">₹</span>
              <span class="amount">100</span>
              <span class="per">/ Instance</span>
            </div>
            <p class="plan-desc">For professional training institutes and corporations requiring advanced, end-to-end
              security.</p>
            <div class="metrics-pills">
              <div class="metric-pill">
                <span class="pill-icon">📚</span>
                <span>Up to 1500 concurrent exams</span>
              </div>
              <div class="metric-pill">
                <span class="pill-icon">🏷️</span>
                <span>Up to 15,000/ month total</span>
              </div>
            </div>
            <a (click)="openSubscriptionModal('Business')" class="btn-price-cta">Get Started</a>
            <div class="card-divider"></div>
          </div>

          <div class="checklist-drawer">
            <div class="included-title">What’s included:</div>
            <ul class="checklist-list">
              <li class="item-included"><span class="check-icon">✓</span> Everything in Standard</li>
              <li class="item-included"><span class="check-icon">✓</span> Advanced Audio & Eye Tracking</li>
              <li class="item-included"><span class="check-icon">✓</span> Custom LMS & API Integrations</li>
              <li class="item-included"><span class="check-icon">✓</span> Priority 24/7 Support</li>
              <li class="item-included"><span class="check-icon">✓</span> Real-Time Analytics Dashboard</li>
              <li class="item-included"><span class="check-icon">✓</span> Advanced Cybersecurity Audits</li>
            </ul>
          </div>
        </div>

        <!-- 4. Customize Plan (Enterprise) -->
        <div class="price-card">
          <div class="card-top-content">
            <h3 class="plan-name">Enterprise</h3>
            <div class="price-rate rate-custom">
              <span class="amount-custom">Custom</span>
            </div>
            <p class="plan-desc">Tailor-made solution for large administration requiring specialized setups.</p>
            <div class="metrics-pills">
              <div class="metric-pill">
                <span class="pill-icon">📚</span>
                <span>Unlimited concurrent exams</span>
              </div>
              <div class="metric-pill">
                <span class="pill-icon">🏷️</span>
                <span>Unlimited total</span>
              </div>
            </div>
            <a (click)="openSubscriptionModal('Enterprise / Custom')" class="btn-price-cta">Contact Us</a>
            <div class="card-divider"></div>
          </div>

          <div class="checklist-drawer">
            <div class="included-title">What’s included:</div>
            <ul class="checklist-list">
              <li class="item-included"><span class="check-icon">✓</span> Everything in Business</li>
              <li class="item-included"><span class="check-icon">✓</span> Dedicated Account Manager</li>
              <li class="item-included"><span class="check-icon">✓</span> On-Premise / Private Cloud Setup</li>
              <li class="item-included"><span class="check-icon">✓</span> Custom SLA & Compliance SLA</li>
              <li class="item-included"><span class="check-icon">✓</span> Custom Proctored Workflows</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- TESTIMONIALS (MARQUEE EDITION) -->
  <section class="testimonials">
    <div class="test-header">
      <div class="test-eyebrow">Testimonials</div>
      <h2>Trusted by <br /><span class="accent-green">those who deliver</span></h2>
    </div>

    <div class="marquee-wrapper">
      <div class="marquee-track">
        <!-- Dynamic Set 1 -->
        <div class="test-card" *ngFor="let item of testimonials">
          <div class="glow-corner"></div>
          <div class="test-person">
            <div class="person-info">
              <h4>{{ item.name }}</h4>
              <span>{{ item.role }}</span>
            </div>
            <div class="org-logo" *ngIf="item.logoUrl" [ngClass]="item.logoClass">
              <img [src]="item.logoUrl" alt="Organization Logo" />
            </div>
          </div>
          <hr class="test-divider" />
          <p class="test-quote">{{ item.quote }}</p>
        </div>

        <!-- Dynamic Set 2 (Duplicate for Seamless Infinite Marquee Loop) -->
        <div class="test-card" *ngFor="let item of testimonials">
          <div class="glow-corner"></div>
          <div class="test-person">
            <div class="person-info">
              <h4>{{ item.name }}</h4>
              <span>{{ item.role }}</span>
            </div>
            <div class="org-logo" *ngIf="item.logoUrl" [ngClass]="item.logoClass">
              <img [src]="item.logoUrl" alt="Organization Logo" />
            </div>
          </div>
          <hr class="test-divider" />
          <p class="test-quote">{{ item.quote }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- FAQ -->
  <section class="faq">
    <div class="faq-header">
      <div class="faq-eyebrow">FAQ</div>
      <h2>Common <span class="accent-green">questions</span></h2>
    </div>

    <div class="faq-accordion-container">
      <div class="faq-row-item" *ngFor="let item of faqs; let i = index" [class.expanded]="activeFaqIndex === i">
        <div class="faq-row-header" (click)="toggleFaq(i)">
          <span class="faq-question-text">{{ item.question }}</span>
          <span class="faq-chevron-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#04523B" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </span>
        </div>
        <div class="faq-row-body" *ngIf="activeFaqIndex === i">
          <p class="faq-answer-text">{{ item.answer }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- FINAL CTA (ANCHOR SECTION) -->
  <div class="final-cta-outer">
    <section class="final-cta">
      <div class="final-cta-text">
        <h2>Build a <span class="accent-green">Secure,</span><br><span class="accent-green">Scalable</span> Assessment
          System</h2>
        <p>Join the organizations that trust Certiplate for their most critical assessments.</p>
        <a (click)="navigateToBookDemo()" class="btn-racing-green">
          <span>Get a Demo</span>
          <span class="cta-arrow-circle">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
              stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </span>
        </a>
      </div>

      <div class="final-visual-stack">
        <img src="assets/final-cta-visual.png" alt="Assessments Delivered and 24/7 Support Illustration"
          class="final-cta-illustration-img" />
      </div>
    </section>
  </div>

  <!-- 16. CERTIFICATION & ACCREDITATION MARQUEE (TRUST BAR) -->
  <section class="trust-marquee-section">
    <div class="trust-marquee-wrapper">
      <div class="trust-marquee-track">
        <!-- Set 1: Individual Certification & Accreditation Logos -->
        <div class="accred-seal-item"><img src="assets/certifications/ncvet.png" alt="NCVET" class="accred-seal-img" />
        </div>
        <div class="accred-seal-item"><img src="assets/certifications/iso.png" alt="ISO 9001:2015"
            class="accred-seal-img" /></div>
        <div class="accred-seal-item"><img src="assets/certifications/mycert.png" alt="myCERT"
            class="accred-seal-img" /></div>
        <div class="accred-seal-item"><img src="assets/certifications/aks.png" alt="AKS" class="accred-seal-img" />
        </div>
        <div class="accred-seal-item"><img src="assets/certifications/qaa.png" alt="Quality Assurance Advisory"
            class="accred-seal-img" /></div>
        <div class="accred-seal-item"><img src="assets/certifications/q2a.png" alt="Q2A UK Certification Board"
            class="accred-seal-img" /></div>
        <div class="accred-seal-item"><img src="assets/certifications/dgt.png" alt="Directorate General of Training"
            class="accred-seal-img" /></div>

        <!-- Set 2: Duplicate for Seamless Infinite Marquee Loop -->
        <div class="accred-seal-item"><img src="assets/certifications/ncvet.png" alt="NCVET" class="accred-seal-img" />
        </div>
        <div class="accred-seal-item"><img src="assets/certifications/iso.png" alt="ISO 9001:2015"
            class="accred-seal-img" /></div>
        <div class="accred-seal-item"><img src="assets/certifications/mycert.png" alt="myCERT"
            class="accred-seal-img" /></div>
        <div class="accred-seal-item"><img src="assets/certifications/aks.png" alt="AKS" class="accred-seal-img" />
        </div>
        <div class="accred-seal-item"><img src="assets/certifications/qaa.png" alt="Quality Assurance Advisory"
            class="accred-seal-img" /></div>
        <div class="accred-seal-item"><img src="assets/certifications/q2a.png" alt="Q2A UK Certification Board"
            class="accred-seal-img" /></div>
        <div class="accred-seal-item"><img src="assets/certifications/dgt.png" alt="Directorate General of Training"
            class="accred-seal-img" /></div>
      </div>
    </div>
  </section>

  <!-- 17. FOOTER (BOTTOM NAVIGATION & LEGAL) -->
  <footer class="site-footer">
    <div class="footer-bar-container">
      <div class="footer-content-row">
        <!-- Logo (Linked to top of page) on Left -->
        <a (click)="scrollToTop()" class="footer-logo-link">
          <img src="assets/images/new-logo.png" alt="Certiplate Logo" class="footer-logo-img" />
        </a>

        <!-- Copyright Notice in Middle/Left -->
        <span class="copyright-text">@ 2026 Certiplate. All Rights Reserved by <a href="http://navriti.com"
            target="_blank" rel="noopener noreferrer" class="copyright-owner-link">NAVRITI TECHNOLOGIES PRIVATE LIMITED</a></span>

        <!-- Legal Links Group on Right -->
        <div class="legal-links-group">
          <a routerLink="/terms-and-conditions" class="legal-link-item">Terms and Conditions</a>
          <a routerLink="/privacy-policy" class="legal-link-item">Privacy</a>
          <a routerLink="/cookie-policy" class="legal-link-item">Cookies</a>
        </div>
      </div>
    </div>
  </footer>

  <!-- SUBSCRIPTION PLAN INQUIRY MODAL -->
  <div class="sub-modal-backdrop" *ngIf="isSubscriptionModalOpen" (click)="closeSubscriptionModal()">
    <div class="sub-modal-card" (click)="$event.stopPropagation()">
      <button class="sub-modal-close" (click)="closeSubscriptionModal()" title="Close Modal">&times;</button>

      <div class="sub-modal-header">
        <div class="sub-badge">Subscription Inquiry</div>
        <h2>Request Details for <span class="accent-green">{{selectedSubscriptionPlan}}</span></h2>
        <p>Fill out the form below to receive a custom quote and plan details sent directly from our sales team.</p>
      </div>

      <!-- Status Alert Message -->
      <div *ngIf="subscriptionStatusMessage" [class]="'sub-status-alert alert-' + subscriptionStatusType">
        <span *ngIf="subscriptionStatusType === 'success'">✓</span>
        <span *ngIf="subscriptionStatusType === 'error'">✕</span>
        <span>{{subscriptionStatusMessage}}</span>
      </div>

      <form [formGroup]="subscriptionForm" (ngSubmit)="submitSubscriptionForm()" class="sub-modal-form">
        <div class="sub-form-group">
          <label>Selected Subscription Plan</label>
          <input type="text" formControlName="planName" readonly class="sub-input input-readonly" />
        </div>

        <div class="sub-form-row">
          <div class="sub-form-group">
            <label>Full Name <span class="required-star">*</span></label>
            <input type="text" formControlName="fullName" placeholder="Enter your full name" class="sub-input"
              [class.input-error]="subscriptionForm.get('fullName')?.touched && subscriptionForm.get('fullName')?.invalid" />
            <small *ngIf="subscriptionForm.get('fullName')?.touched && subscriptionForm.get('fullName')?.invalid"
              class="sub-field-error">Full name is required.</small>
          </div>

          <div class="sub-form-group">
            <label>Email Address <span class="required-star">*</span></label>
            <input type="email" formControlName="email" placeholder="name@company.com" class="sub-input"
              [class.input-error]="subscriptionForm.get('email')?.touched && subscriptionForm.get('email')?.invalid" />
            <small *ngIf="subscriptionForm.get('email')?.touched && subscriptionForm.get('email')?.invalid"
              class="sub-field-error">Valid email is required.</small>
          </div>
        </div>

        <div class="sub-form-row">
          <div class="sub-form-group">
            <label>Phone Number <span class="required-star">*</span></label>
            <input type="tel" formControlName="phoneNumber" placeholder="10-digit mobile number" class="sub-input"
              [class.input-error]="subscriptionForm.get('phoneNumber')?.touched && subscriptionForm.get('phoneNumber')?.invalid" />
            <small *ngIf="subscriptionForm.get('phoneNumber')?.touched && subscriptionForm.get('phoneNumber')?.invalid"
              class="sub-field-error">Valid 10-digit mobile number is required.</small>
          </div>

          <div class="sub-form-group">
            <label>Company / Organization</label>
            <input type="text" formControlName="company" placeholder="e.g. University / Enterprise name"
              class="sub-input" />
          </div>
        </div>

        <div class="sub-form-group">
          <label>Plan Requirements / Questions</label>
          <textarea formControlName="message" rows="3"
            placeholder="Tell us about your estimated concurrent exams or specific feature requirements..."
            class="sub-textarea"></textarea>
        </div>

        <button type="submit" [disabled]="isSubmittingSubscription" class="btn-sub-submit">
          <span *ngIf="!isSubmittingSubscription">Submit Plan Inquiry &rarr;</span>
          <span *ngIf="isSubmittingSubscription">Sending Inquiry...</span>
        </button>
      </form>
    </div>
  </div>

  <!-- Cookie Consent Banner -->
  <div class="cookie-banner" *ngIf="showCookieBanner">
    <div class="cookie-content">
      <h3>Cookie Collection</h3>
      <p>
        We use cookies and other tracking technologies on our website, some of which are placed by third parties. We do this to ensure the functionalities on the site, measure and analyze user traffic and create general statistics regarding the use of the page, as well as for targeted marketing, such as retargeting.
      </p>
      <p>
        By clicking on "Accept All", you agree that we and third parties may place cookies for these purposes and that we and third parties may use your collected personal information (e.g. IP address, device ID and browsing behavior) in the context of targeted marketing, cf. GDPR article 6, 1 (a). Our processing of collected personal data for the other purposes are based on our legitimate interest, cf. GDPR article 6, 1 (f).
      </p>
    </div>
    <div class="cookie-actions">
      <button class="btn-cookie-accept" (click)="acceptCookies()">Accept All</button>
      <div class="cookie-actions-row">
        <button class="btn-cookie-reject" (click)="rejectCookies()">Reject All</button>
        <button class="btn-cookie-policy" routerLink="/cookie-policy">Cookie Policy</button>
      </div>
    </div>
  </div>
</div>